import React from 'react';
import { Tooltip } from './Tooltip';
type AvatarSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl';
interface AvatarProps {
  name: string;
  id: number;
  src?: string;
  size?: AvatarSize;
  className?: string;
  showTooltip?: boolean;
  status?: 'online' | 'offline' | 'away' | 'busy';
}
export function Avatar({
  name,
  id,
  src,
  size = 'md',
  className = '',
  showTooltip = false,
  status
}: AvatarProps) {
  // Get size in pixels
  const sizeMap = {
    xs: 'h-6 w-6 text-xs',
    sm: 'h-8 w-8 text-sm',
    md: 'h-10 w-10 text-base',
    lg: 'h-12 w-12 text-lg',
    xl: 'h-16 w-16 text-xl'
  };
  const sizeClass = sizeMap[size] || sizeMap.md;
  // Generate initials from name
  const getInitials = (name: string) => {
    if (!name) return '??';
    const parts = name.split(' ');
    if (parts.length === 1) {
      return name.substring(0, 2).toUpperCase();
    }
    return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
  };
  // Generate a deterministic color based on the ID
  const getBackgroundColor = (id: number) => {
    const colors = ['bg-blue-600', 'bg-green-600', 'bg-yellow-600', 'bg-red-600', 'bg-purple-600', 'bg-pink-600', 'bg-indigo-600', 'bg-teal-600'];
    return colors[id % colors.length];
  };
  // Status indicator styles
  const statusStyles = {
    online: 'bg-green-500',
    offline: 'bg-gray-500',
    away: 'bg-yellow-500',
    busy: 'bg-red-500'
  };
  const avatar = <div className="relative" data-id="element-760">
      <div className={`${sizeClass} ${getBackgroundColor(id)} rounded-full flex items-center justify-center text-white font-semibold shadow-sm ${className}`} title={name} data-id="element-761">
        {src ? <img src={src} alt={name} className="h-full w-full object-cover rounded-full" onError={e => {
        // If image fails to load, show initials instead
        e.currentTarget.style.display = 'none';
      }} data-id="element-762" /> : getInitials(name)}
      </div>
      {status && <span className={`absolute bottom-0 right-0 block h-2.5 w-2.5 rounded-full ring-2 ring-gray-800 ${statusStyles[status]}`} aria-hidden="true" data-id="element-763" />}
    </div>;
  if (showTooltip) {
    return <Tooltip content={name} position="top" data-id="element-764">
        {avatar}
      </Tooltip>;
  }
  return avatar;
}